import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchSaleStatus = () => api.get("/sale/status").then((r) => r.data);
export const fetchTopTokens = () => api.get("/tokens/top/list").then((r) => r.data);
export const fetchToken = (n) => api.get(`/tokens/${n}`).then((r) => r.data);
export const fetchTokens = (params) => api.get("/tokens", { params }).then((r) => r.data);
export const fetchAuctionInfo = (n) =>
    api.get(`/auction/${n}/info`).then((r) => r.data);
export const placeBid = (token_number, bidder, amount) =>
    api.post("/auction/bid", { token_number, bidder, amount }).then((r) => r.data);
export const submitMint = (payload) => api.post("/mint", payload).then((r) => r.data);
export const fetchWalletTokens = (addr) =>
    api.get(`/wallet/${addr}/tokens`).then((r) => r.data);
export const fetchAdminTopTokens = () =>
    api.get("/admin/top-tokens").then((r) => r.data);
export const updateAdminTopTokens = (top_tokens) =>
    api.post("/admin/top-tokens", { top_tokens }).then((r) => r.data);
export const fetchSocials = () => api.get("/socials").then((r) => r.data);
export const updateSocials = (socials) =>
    api.post("/admin/socials", socials).then((r) => r.data);

export const tokenImage = (lat, lon, zoom = 5) => {
    const tk = process.env.REACT_APP_MAPBOX_TOKEN;
    if (!tk) return null;
    const safeLat = Math.max(Math.min(lat, 85), -85);
    return `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/${lon},${safeLat},${zoom},0/600x400?access_token=${tk}`;
};
